import Vue from 'vue'
import { DateTime } from 'luxon'
import { mapGetters, mapMutations, mapActions } from 'vuex'

const mixins = Vue.mixin({
  computed: {
    ...mapGetters(['progress', 'settings', '_', 'filter', 'favorites', 'key', 'timezone']),
  },
  methods: {
    ...mapMutations(['setProgress', 'setBack', 'setUser', 'setModal']),
    ...mapActions(['getSessions', 'getUser']),
    timeZoneOffset(date) {
      const event = DateTime.fromSQL(date, { zone: this.settings.app.timezone });
      const local = DateTime.fromSQL(date, { zone: Intl.DateTimeFormat().resolvedOptions().timeZone });
      return local.offset - event.offset;
    },
    formatDay(day) {
      return this._.date_format_program
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name])
        .replace('&y', day.year);
    },
    formatTime(day, time) {
      const offset = this.timeZoneOffset(day.date);
      const options = { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' };
      let stamp = Date.parse('01 Jan 1970 ' + time + ' UTC');
      if (this.timezone === 'local') stamp += (offset * 60000);
      let suffix = '';
      if (stamp < 0) suffix = '<sup>-1</sup>';
      if (stamp > 86400000) suffix = '<sup>+1</sup>';
      return new Date(stamp).toLocaleTimeString([], options) + suffix;
    },
    formatDayTimes(day, start, end) {
      return this.formatDay(day) + ', ' + this.formatTime(day, start) + ' &ndash; ' + this.formatTime(day, end);
    },
    formatTimes(day, start, end) {
      return this.formatTime(day, start) + ' &ndash; ' + this.formatTime(day, end);
    },
  }
})

export default mixins
